/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_NormalInputs */

const cs_enum_normal = /** @type {(inputs: Enum_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Běžná`)
};

const en_enum_normal = /** @type {(inputs: Enum_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

/**
* | output |
* | --- |
* | "Normal" |
*
* @param {Enum_NormalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_normal = /** @type {((inputs?: Enum_NormalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_NormalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_normal(inputs)
	return cs_enum_normal(inputs)
});